import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Loading from './Loading';

const API_URL = `https://rickandmortyapi.com/api/character`

function Character() {
    const [character, setCharacter] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const { id } = useParams();
    const history = useNavigate();

    useEffect(() => {
        fetch(`${API_URL}/${id}`)
            .then(response => response.json())
            .then(data => {
                setCharacter(data);
                setIsLoading(false);
            })
            .catch(error => console.log(error));
    }, [id]);

    const handleGoBack = () => {
        history(-1);
    };

    if (isLoading) {
        return <Loading />;
    }

    const { name, image, gender, status, species, origin, type } = character;

    return (
        <div className='container container-detailed'>
            <button className='btn-back' onClick={handleGoBack}>Go back</button>
            <img className='character-img__detailed' src={image} alt={name} />
            <h2 className='character-title'>{name}</h2>
            <p className='character-info'>Informations</p>
            <div className='character-description'>
                <p className='character-feature'>Gender <span className='character-span'>{gender}</span></p>
                <p className='character-feature'>Status <span className='character-span'>{status}</span></p>
                <p className='character-feature'>Specie <span className='character-span'>{species}</span></p>
                <p className='character-feature'>Origin <span className='character-span'>{origin.name}</span></p>
                <p className='character-feature'>Type <span className='character-span'>{type || 'Unknown'}</span></p>
            </div>
        </div>
    );
}

export default Character;
